export enum NavStepStatusID {
  Unknown = 'unknown',
  NotDone = 'not-done',
  Done = 'done',
  Current = 'current',
}
export class NavStep {
  constructor(
    public name: string = '',
    public routeSecName: string = '',
    public visible: boolean = true,
    public status: NavStepStatus = NavStepStatusID.NotDone,
  ) {
  }
}

export type NavStepStatus = NavStepStatusID.Unknown | NavStepStatusID.NotDone |
  NavStepStatusID.Done | NavStepStatusID.Current;
export interface StepperName {
  overview: string;
  practiceAreas: string;
  trustAccountDetails: string;
  declaration: string;
  confirmation: string;
  trustAccountingRecords: string;
  generalTrustMoney: string;
  controlledMoney: string;
  specificPowerMoney: string;
  investmentMoney: string;
  otherInformation: string;
  breaches: string;
}

export const Step: StepperName = {
  overview: 'Overview',
  practiceAreas: 'Practice Areas',
  trustAccountDetails: 'Trust Account Details',
  declaration: 'Declaration',
  confirmation: 'Confirmation',
  trustAccountingRecords: 'Trust Accounting Records',
  generalTrustMoney: 'General Trust Money',
  controlledMoney: 'Controlled Money',
  specificPowerMoney: 'Specific Power Money',
  investmentMoney: 'Investment Money',
  otherInformation: 'Other Information',
  breaches: 'Breaches',
}

export interface SectionName {
  overview: string;
  practiceAreas: string;
  trustAccountDetails: string;
  declaration: string;
  confirmation: string;
  trustAccountingRecords: string;
  generalTrustMoney: string;
  controlledMoney: string;
  specificPowerMoney: string;
  investmentMoney: string;
  otherInformation: string;
  breaches: string;
}

export const Section: SectionName = {
  overview: 'overview',
  practiceAreas: 'practice-areas',
  trustAccountDetails: 'trust-account-details',
  declaration: 'declaration',
  confirmation: 'confirmation',
  trustAccountingRecords: 'trust-account-records',
  generalTrustMoney: 'general-trust-money',
  controlledMoney: 'controlled-money',
  specificPowerMoney: 'specific-power-money',
  investmentMoney: 'investment-money',
  otherInformation: 'other-information',
  breaches: 'breaches',
}
